module.exports = __webpack_public_path__ + "static/metamagical-themas-e83b2ccbc59ad35f2f1b5c5a62427a8d.jpg";